import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import { ReplenishmentTaskV3InitialStateType } from 'features/SupplyOrder/@types/ReplenishmentV3'
import { SLICE_NAME, fetchReplenishmentPutawayTask } from './thunk'

type ReplenishmentPutawayInitialStateType = Pick<
  ReplenishmentTaskV3InitialStateType,
  'isLoading' | 'data'
>

const initialState: ReplenishmentPutawayInitialStateType = {
  isLoading: false,
  data: [],
}

const replenishmentTaskSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetReplenishmentTaskV3State: () => initialState,
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<ReplenishmentTaskV3InitialStateType>) => {
      builder.addCase(fetchReplenishmentPutawayTask.fulfilled, (state, action) => {
        state.data = action.payload.data
      })
    },
    [fetchReplenishmentPutawayTask],
  ),
})

export const { resetReplenishmentTaskV3State } = replenishmentTaskSlice.actions
export default replenishmentTaskSlice.reducer
